<script setup lang="ts">
export type TButtonType = 1 | 2 | '1' | '2';

type TButtonStyles = {
  normal: string;
  hover: string;
  active: string;
  disabled: string;
};

const props = withDefaults(
  defineProps<{ active?: boolean; disabled?: boolean; title?: string; type?: TButtonType }>(),
  {
    title: '',
    disabled: false,
    active: false,
    type: 1,
  },
);

const styleClasses: Record<TButtonType, TButtonStyles> = {
  1: {
    normal: 'font-medium border-gray-500 bg-gray-100',
    hover: 'hover:border-gray-500 hover:bg-gray-300',
    active: 'active:translate-y-[1px]',
    disabled: 'disabled:pointer-events-none disabled:bg-gray-100 disabled:text-gray-900/50',
  },

  2: {
    normal: 'border-gray-300 bg-gray-300',
    hover: 'hover:border-gray-500 hover:bg-gray-300',
    active: 'active:translate-y-[1px]',
    disabled: 'disabled:pointer-events-none disabled:bg-gray-100 disabled:text-gray-900/50',
  },
};

const typedStyles = computed(
  () => {
    if (!props.disabled && props.active) {
      return 'border-blue-500 bg-blue-200 active:translate-y-[1px]';
    }
    return `${styleClasses[props.type].normal} `
      + `${styleClasses[props.type].hover} `
      + `${styleClasses[props.type].active} `
      + `${styleClasses[props.type].disabled} `;
  }
  ,
);

const emit = defineEmits(['click']);

const onClick = () => {
  if (props.disabled) return;

  // active.value = !active.value;
  emit('click');
};
// TODO: there is a ssr prerender issue with elements when using butoon with via LanguageSelect.vue component
// temporary fix is to use div instead of button and don't have disabled state
</script>

<template>
  <div class="relative">
    <div
      :class="typedStyles"
      class="px-4 py-2 h-9 text-sub text-gray-900 border cursor-pointer select-none text-center outline-none rounded flex gap-2 justify-between items-center whitespace-nowrap"
      @click="onClick"
    >
      <slot name="prepend" />
      <template v-if="title">
        {{ title }}
      </template>

      <slot name="append" />
    </div>
    <slot name="default" />
  </div>
</template>

<style scoped></style>
